
/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */ 

export const Routes = { 
    TemplateIds: {
        
        Announcement : "9ADD796498B04E0696EF30A38644D9DD",
        AnnouncementV2 : "AD8DD1E9646E42E8BD70530ECFC52418",
        ArticleListingPage : "E3971B84ABB24651BA40AE72B63DACDD",
        ArticlePage : "D22C971E5C38427B9091DF8E98F59169",
        CampaignPage : "6B0C7E4D01F447BD8C2C7FE5542A2421",
        CartPage : "E2066F0D0F1D4E4CB7F2AD0792CA0C26",
        EducationCatalogPage : "6D4B2BD95E9640C1813BEDD4E4931124",
        ErrorPage : "7D689F5FB02945B2919D1C646146A0C6",
        EventListingPage : "DDBDDC6754AF4EC4930665489AA62FFD",
        EventPage : "CD197981672F47EAAB901D85B701A119",
        ExecutivePage : "5BD51827886541ED99CA2A235D314551",
        GenericPage : "2002B16B4B22521A80781C28ED81DE29",
        HomePage : "8DE1FA3B0D8E4605A261F7DCD9FF27A2",
        ProductDetailsPage : "569B2BD604504FFB93231531E8832ED3",
        Redirect : "3947438554BB4F44BCBB2B2EA1DF91C6",
        SearchListingPage : "AB38EEC2D2E04452B093B34E2DFFF555",
        SearchPage : "FCDCF55D27E9417CA6E176E1242AA8E6"    
    }
}


